@if (!isFinished()) {
  <div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
      <a (click)="back()">
        <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
      </a>
      <div class="p-2 flex-grow-1 pl-2">
        <h1 class="text-dark text-center">Solicitud Alta Especialidad y Prestación</h1>
      </div>
    </div>

    <div class="row-cols-12 m-2 mt-0">
      <div class="row p-3 mb-0 align-items-center">
        <div class="mb-3 mt-0 text-start">
          <form (ngSubmit)="solicitudEspecialidadPrestacion()" [formGroup]="solicitudServicioEspecialidad">

            <div class="row mt-4">
              <div class="col">
                <label for="especialidad" class="form-label">Especialidad</label>
                <input type="text" class="form-control" id="especialidad" formControlName="especialidad">

                @if (
                  solicitudServicioEspecialidad.controls['especialidad'].invalid &&
                  (solicitudServicioEspecialidad.controls['especialidad'].dirty || solicitudServicioEspecialidad.controls['especialidad'].touched) &&
                  solicitudServicioEspecialidad.controls['especialidad'].errors?.['required']
                ) {
                  <div class="alert-danger" role="alert">
                    <small class="alert">Debe ingresar una Especialidad</small>
                  </div>
                }
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <label for="prestacion" class="form-label">Prestación</label>
                <input type="text" class="form-control" id="prestacion" formControlName="prestacion">

                @if (
                  solicitudServicioEspecialidad.controls['prestacion'].invalid &&
                  (solicitudServicioEspecialidad.controls['prestacion'].dirty || solicitudServicioEspecialidad.controls['prestacion'].touched) &&
                  solicitudServicioEspecialidad.controls['prestacion'].errors?.['required']
                ) {
                  <div class="alert-danger" role="alert">
                    <small class="alert">Debe ingresar una prestación</small>
                  </div>
                }
              </div>
            </div>

            @if (error().length > 0) {
              <div class="alert alert-danger mt-2" role="alert">
                <small>{{ error() }}</small>
              </div>
            }

            <div class="d-grid mt-5 mb-3 pb-3">
              <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">
                {{ loading() ? 'Cargando...' : 'Enviar solicitud' }}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="container mt-5 fade-in-left" id="centerFrameTwo">
    <div class="row p-3 mb-3 mt-5 align-items-center">
      <div class="mt-5">
        <div class="row form-switch ps-0 mb-3">
          <div class="col text-center sucess-text mt-5 mb-5">
            <b>
              <span class="bluetext"><strong>Tu solicitud fue enviada.</strong></span><br>
              Te notificaremos a la brevedad
            </b>
          </div>
        </div>
      </div>

      <div class="d-grid mt-3 mb-3 pb-3">
        <button type="button" class="btn btn-primary btn-lg mt-0" (click)="back()">Volver</button>
      </div>
    </div>
  </div>
}
